<template>
  <v-app class="bgImage">
    <m-errorbox ref="errorBox"></m-errorbox>
    <navbar>
      <v-toolbar-title class="text-uppercase secondary--text text--darken-3">
        <span class="font-weight-light">My</span>
        <span class="font-weight-medium">Devices</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <m-menubutton icon="mdi-plus-circle" @click="$router.push('all_devices')">Add Device</m-menubutton>
      <v-spacer></v-spacer>
    </navbar>
    <v-content class="secondary--text text--darken-2">
      <v-container fluid fill-height align-content-start>
        <v-row v-if="$store.state.networkAvailable">
          <v-col>
            <h2 class="text-center text-uppercase">My Devices</h2>
          </v-col>
        </v-row>

        <v-row>
          <v-col v-if="$store.state.networkAvailable">
            <resource-cards
              empty-message="You do not have any devices in your personal list.  Click 'Add Device' in the top bar to add a device to this page."
              error-message="Error loading device list from server!"
              :prepare-item="prepareDeviceInfo"
              :index-endpoint="apiEndpoints.myDevices"
              :delete-endpoint="apiEndpoints.removeDevice"
              :polling-interval="15000"
            >
              <template v-slot:default="{item, index, deleteItem}">
                <v-card class="ma-3" @click="$router.push('/log/' + item.id)">
                  <v-list-item three-line>
                  <v-list-item-avatar size="24" left>
                  <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on">mdi-dots-vertical</v-icon>
                    </template>
                    <v-list>
                      <v-list-item @click="$router.push('/deviceinfo/' + item.id)">
                        <v-list-item-title>
                          <v-icon left>mdi-information-outline</v-icon>Device Info
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="$router.push('/create_link/' + item.id)">
                        <v-list-item-title>
                          <v-icon left>mdi-share-variant</v-icon>Create Shareable Link
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="$router.push('/log/' + item.id)">
                        <v-list-item-title>
                          <v-icon left>mdi-chart-timeline-variant</v-icon>Device Log
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="deleteItem(item.id)">
                        <v-list-item-title>
                          <v-icon left class="red--text">mdi-alert-circle</v-icon>Remove from My Devices
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-list-item-avatar>






                    <v-list-item-content>
                      <v-list-item-title v-if="item.device_name">{{item.device_name}}</v-list-item-title>
                      <v-list-item-title v-else>{{item.device_token}}</v-list-item-title>
                      <v-list-item-subtitle v-if="item.online">ONLINE</v-list-item-subtitle>
                      <v-list-item-subtitle v-else>OFFLINE</v-list-item-subtitle>

                      <v-list-item-subtitle>{{ item.last_contact.getFullYear() < 2001 ? "Never been online" : "Last Seen " + fullDateTime(item.last_contact)}}</v-list-item-subtitle>
                      <v-list-item-subtitle
                        v-if="lastDeviceLocation[index] && lastDeviceLocation[index].address"
                      >{{ lastDeviceLocation[index].address }}</v-list-item-subtitle>
                    </v-list-item-content>

                    <v-list-item-avatar
                      :color="item.online ? 'primary' : 'secondary'"
                      size="62"
                      right
                    >
                      <v-icon v-if="item.online" size="40">mdi-access-point-network</v-icon>
                      <v-icon v-else size="40">mdi-access-point-network-off</v-icon>
                    </v-list-item-avatar>
                  </v-list-item>
                </v-card>
              </template>
            </resource-cards>
          </v-col>
          <v-col v-else class="text-center">
            <v-chip class="ma-2" color="warning text--secondary" light>
        <v-icon left>mdi-server-network-off</v-icon>Cloud connected devices are not available offline
  </v-chip>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import usbRequestMixin from "../mixins/usb-request";
import apiRequestMixin from "../mixins/api-request";
import apiEndpointsMixin from "../mixins/api-endpoints";
import formatDateMixin from "../mixins/format-date";
import geoFunctions from "../mixins/geo-functions";

export default {
  mixins: [
    usbRequestMixin,
    apiRequestMixin,
    apiEndpointsMixin,
    formatDateMixin,
    geoFunctions
  ],
  data() {
    return {
      lastDeviceLocation: []
    };
  },
  created() {},
  methods: {
    showError(message) {
      // errors can occur after the page has been navigated away from.
      if (this.$refs.errorBox) {
        this.$refs.errorBox.showError(message);
      }
    },
    openDevice(id) {
      this.$router.push("/device/" + id);
    },
    updateDeviceAddress(value, index) {
      if (value.latitude != null && value.longitude != null) {
        if (this.lastDeviceLocation[index]) {
          let distance = Math.abs(
            this.distance(
              this.lastDeviceLocation[index].latitude,
              this.lastDeviceLocation[index].longitude,
              value.latitude,
              value.longitude,
              "K"
            )
          );

          console.log("Distance", distance, "km");
          if (distance > 0.2) {
            // if the GPS readings vary by more than 200m, the reload the address
            this.getAddress(value.latitude, value.longitude).then(address => {
              this.lastDeviceLocation[index].address = address;
            });
          }
        } else {
          // the device location has not yet been recorded, so add it to the record
          Vue.set(this.lastDeviceLocation, index, {
            latitude: value.latitude,
            longitude: value.longitude,
            address: ""
          });
          this.getAddress(value.latitude, value.longitude).then(address => {
            this.lastDeviceLocation[index].address = address;
          });
        }
      }
    },
    prepareDeviceInfo(value, index) {
      value.last_contact = new Date(value.last_contact * 1000);
      this.updateDeviceAddress(value, index);
    }
  }
};
</script>
